var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInfoIconSmall(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 10,
    cy: 10,
    r: 9.20833,
    stroke: "#ffffff",
    strokeWidth: 1.58333
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.0242 6.71545C9.70275 6.71545 9.43312 6.60656 9.21534 6.38878C8.99756 6.171 8.88867 5.90137 8.88867 5.57989C8.88867 5.25841 8.99756 4.98878 9.21534 4.771C9.43312 4.55323 9.70275 4.44434 10.0242 4.44434C10.3353 4.44434 10.5998 4.55323 10.8176 4.771C11.0353 4.98878 11.1442 5.25841 11.1442 5.57989C11.1442 5.90137 11.0353 6.171 10.8176 6.38878C10.5998 6.60656 10.3353 6.71545 10.0242 6.71545ZM10.8953 7.851V15.311H9.12201V7.851H10.8953Z",
    fill: "#ffffff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfoIconSmall);
export default __webpack_public_path__ + "static/media/infoIconSmall.cee88e9983930aa80e278d9616ea1ebc.svg";
export { ForwardRef as ReactComponent };